<svg [attr.width]="width" [attr.height]="height" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M40.3354 211.889C38.0656 208.295 36.9307 206.498 36.2954 203.726C35.8182 201.644 35.8182 198.361 36.2954 196.279C36.9307 193.507 38.0656 191.71 40.3354 188.116C59.0921 158.417 114.923 83.3359 200.007 83.3359C285.09 83.3359 340.921 158.417 359.678 188.116C361.948 191.71 363.083 193.507 363.718 196.279C364.195 198.361 364.195 201.644 363.718 203.726C363.083 206.498 361.948 208.295 359.678 211.889C340.921 241.589 285.09 316.669 200.007 316.669C114.923 316.669 59.0922 241.589 40.3354 211.889Z"
    stroke="var(--stroke-color)"
    stroke-width="33.3333"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M200.007 250.003C227.621 250.003 250.007 227.617 250.007 200.003C250.007 172.388 227.621 150.003 200.007 150.003C172.392 150.003 150.007 172.388 150.007 200.003C150.007 227.617 172.392 250.003 200.007 250.003Z"
    stroke="var(--stroke-color)"
    stroke-width="33.3333"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
